module.exports = __webpack_public_path__ + "img/hr-water4.eb6554a9.png";